<template>
	<div id="publish">
		<div class="header">
	      <i class="fa fa-angle-left" @click="back"></i>
	      	招商发布
	    </div>
	    <div class="banner">
	    	<img src="@/assets/imgs/inviteBusiness/inviteBusiness_carousel.png"/>
	    </div>
	    <div class="container_invitebusiness">
	    	<div class="title">
	    		<!--招商发布表-->
	    		<img src="@/assets/imgs/inviteBusiness/Group 4.png"/>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		招商商铺地址
	    	</div>
	    	<div class="address">
	    		<div class="address-top" @click="showPickCity=true">
	    			<div class="flex1 addressflex1">
	    				<span>{{prov}}</span>
	    			</div>
	    			<div class="flex1 addressflex1">
	    				<span>{{city}}</span>
	    			</div>
	    			<div class="flex1 addressflex1">
	    				<span>{{adminDevision}}</span>
	    			</div>
	    		</div>
	    		<div class="address-center" @click="showPickPark = true">
	    			<input type="text" v-model="parkName" placeholder="物流园区名" readonly="readonly"/>
	    		</div>
	    		<div class="address-center">
	    			<input type="text" placeholder="请填写招商商铺地址" v-model="params2.address"/>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		招商标题
	    	</div>
	    	<div class="address">
	    		<div class="address-top">
	    			<div class="flex">
	    				<input class="inviteinput" v-model="params2.title" type="text" placeholder="请输入招商标题" />
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		招商负责人
	    	</div>
	    	<div class="address">
	    		<div class="address-top">
	    			<div class="flex-left">
	    				<input type="text" v-model="params2.contactor" placeholder="负责人姓名"/>
	    			</div>
	    			<div class="flex">
	    				<input class="inviteinput" v-model="params2.phone" type="text" placeholder="请填写负责人联系电话"/>
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		面积区间
	    	</div>
	    	<div class="address">
	    		<div class="address-top">
	    			<div class="flex">
	    				<input class="address-top-area" type="text" v-model="params2.minArea"/>
	    				<span>m³</span>
	    			</div>
	    			<div class="center">
	    				~
	    			</div>
	    			<div class="flex">
	    				<input class="address-top-area" type="text" v-model="params2.maxArea"/>
	    				<span>m³</span>
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>&nbsp;&nbsp;</span>
	    		价格区间
	    	</div>
	    	<div class="address">
	    		<div class="address-top">
	    			<div class="flex">
	    				<input class="address-top-area" type="text" v-model="params2.minPrice"/>
	    				<span>￥</span>
	    			</div>
	    			<div class="center">
	    				~
	    			</div>
	    			<div class="flex">
	    				<input class="address-top-area" type="text" v-model="params2.maxPrice"/>
	    				<span>￥</span>
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		用途类型(可多选)
	    	</div>
	    	<div class="address">
	    		<div class="typebox">
	    			<div class="typelist" v-for="n in typelist">
	    				<label class="checkBox">
						<input name="sf" v-model="typelistdata" type="checkbox" :value="n"/>
							&nbsp<span>{{n}}</span>
						</label>
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		园区配套(可多选)
	    	</div>
	    	<div class="address">
	    		<div class="typebox">
	    			<div class="typelist" v-for="n in PeiTaoList">
	    				<label class="checkBox" >
						<input name="sf"  v-model="PeiTaoListdata" type="checkbox" :value="n"/>
							&nbsp<span>{{n.labelName}}</span>
						</label>
	    			</div>
	    			<div class="typelist addbox" @click="addType('PeiTao')">
	    				新增
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		优惠信息
	    	</div>
	    	<div class="address">
	    		<div class="typebox">
	    			<div class="typelist" v-for="n in YouHuiList">
	    				<label class="checkBox">
						<input name="youhui" v-model="YouHuiListdata" type="radio" :value="n"/>
							&nbsp<span>{{n.labelName}}</span>
						</label>
	    			</div>
	    			<div class="typelist addbox" @click="addType('YouHui')">
	    				新增
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		押金方式
	    	</div>
	    	<div class="address">
	    		<div class="typebox">
	    			<div class="typelist" v-for="n in YaJinList">
	    				<label class="checkBox">
						<input name="yajin" v-model="YaJinListdata" type="radio" :value="n"/>
							&nbsp<span>{{n.labelName}}</span>
						</label>
	    			</div>
	    			<div class="typelist addbox" @click="addType('YaJin')">
	    				新增
	    			</div>
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		简介图
	    	</div>
	    	<div class="photomain">
	    		<div class="photobox">
	    			<img :src="params2.imageUrl" alt="" />
	    			<input class="inputBt" type="file" accept="image/*" @change="selectedImg($event,'info')">
	    		</div>
	    	</div>
	    	<div class="title_sub">
	    		<span>*</span>
	    		轮播图
	    	</div>
	    	<div class="photomain">
	    		<div class="photobox">
	    			<img :src="scrollimg1" alt="" />
	    			<input class="inputBt" type="file" accept="image/*" @change="selectedImg($event,'1')">
	    		</div>
	    		<div class="photobox">
	    			<img :src="scrollimg2" alt="" />
	    			<input class="inputBt" type="file" accept="image/*" @change="selectedImg($event,'2')">
	    		</div>
	    		<div class="photobox">
	    			<img :src="scrollimg3" alt="" />
	    			<input class="inputBt" type="file" accept="image/*" @change="selectedImg($event,'3')">
	    		</div>
	    	</div>
	    	<!--<div class="title_sub">
	    		<span></span>
	    		视屏
	    	</div>
	    	<div class="photomain">
	    		<div class="photobox" v-for="n in params2.scrollImageUrl">
	    			<img :src="n" alt="" />
	    		</div>
	    		<div class="photobox">
	    			<input type="file" name="file" id="videoUpload" @change="selectedVideo($event)" multiple="multiple">
	    		</div>
	    	</div>-->
	    	<div class="title_sub">
	    		<span>*</span>
	    		招商概况
	    	</div>
	    	<div class="address">
	    		<div class="address-invitetext">
	    			<div class="flex">
	    				<textarea class="invitetext" v-model="params2.remark" placeholder="请描述下商铺情况(限200字)" />
	    			</div>
	    		</div>
	    	</div>
	    	<div class="address">
	    		<button class="publish" @click="addInvite">上传发布</button>
	    	</div>
	    </div>
	    <div class="notice">
	    	<div class="top">
	    		填写招商资料必须真实有效 
	    	</div>
	    	<div class="center">
	    		Fill in investment promotion materials must be true and effective 
	    	</div>
	    	<div class="top">
	    		 咨询热线：010-58565158 18122301771 郭先生
	    	</div>
	    </div>
	    <cityPick @emitCity="emitCity" :chooseArea="true" @closePick="showPickCity=false" v-if="showPickCity"></cityPick>   
	    <div class="dropProvice" v-if="showPickPark">
	    	<div class="header itemCenter space-between">
				<i class="fa fa-angle-left" @click="closePickPark" ></i>
				<span>选择物流园</span>
			</div>
	
			<div class="lc_cityTab flex-column-1 flex-column">
				<ul class="lc_proList flex fwrap">
					<li v-for="n in parkList" @click="closePickPark(n)" class="flex itemCenter fCenter">{{n.parkName}}</li>
				</ul>
			</div>
	    </div>
	</div>
</template>

<script>
	import {GET_PARKDISTRICTCODEWITHTICKET,UPLOAD,ADD_ZHAOSHANGCONF} from '@/assets/configs/api/yuanqu'
	import { MessageBox,Toast  } from 'mint-ui';
	export default {
		data(){
			return{
				prov:"省份",
				city:"城市",
				adminDevision:"区域",
				parkList:[],
				parkName:"",
				params2: {
                    id: '',
                    provCode: '',
                    cityCode: '',
                    adminDevisionCode: '',
                    title: '',
                    type: '',
                    minArea: '',
                    maxArea: '',
                    purpose: '',
                    address: '',
                    phone: '',
                    contactor: '',
                    price: '',
                    minPrice: '',
                    maxPrice: '',
                    summary: '',
                    nearby: '',
                    imageUrl: '',
                    videoUrl: '',
                    detailImgUrl: '',
                    scrollImageUrl: [],
                    remark: '',
                    logisticsParkCode: '',
                    trafficSituation: '',
                    contactorAvatarUrl: '',
                    zhanShangLabels: [],
                    area: 'm²',
                    place: '',
                },
                scrollimg1:"",
                scrollimg2:"",
                scrollimg3:"",
                showPickPark:false,
				showPickCity:false,
				value:[],
				typelist:['物流专线','宿舍','仓库','办公司','商铺','其他'],
				YouHuiList: [{
                    labelName: "年租首月5折",
                    isCustom: false,
                    labelType: "YouHui",
                    isChecked: false
                }, {labelName: "全年租金5折", isCustom: false, labelType: "YouHui", isChecked: false}],
                YaJinList: [{labelName: "交一押三", isCustom: false, labelType: "YaJin", isChecked: false},{labelName: "交一押二", isCustom: false, labelType: "YaJin", isChecked: false},{labelName: "交一押一", isCustom: false, labelType: "YaJin", isChecked: false},{labelName: "免押金", isCustom: false, labelType: "YaJin", isChecked: false}],
                PeiTaoList: [{
                    labelName: "中央空调",
                    isCustom: false,
                    labelType: "PeiTao",
                    isChecked: false
                }, {labelName: "免费WIFi", isCustom: false, labelType: "PeiTao", isChecked: false}, {
                    labelName: "精装修",
                    isCustom: false,
                    labelType: "PeiTao",
                    isChecked: false
                }, {labelName: "商业配套齐全", isCustom: false, labelType: "PeiTao", isChecked: false}, {
                    labelName: "园区专线齐全",
                    isCustom: false,
                    labelType: "PeiTao",
                    isChecked: false
                }, {labelName: "车辆集聚", isCustom: false, labelType: "PeiTao", isChecked: false}],
				data:[],
				PeiTaoListdata:[],
				YouHuiListdata:{},
				YaJinListdata:{},
				typelistdata:[]
			}
		},
		methods:{
			back(){
				history.go(-1)
			},
			selectedImg(event,type) {
		      	var file = event.target.files[0]
		      	let config = {
		  			headers: {
		  				"Content-Type": "multipart/form-data"
		  			}
		  		}
		  		let param = new FormData(); //创建form对象
		        param.append('imgFiles', file);
		  		this.$post(UPLOAD,
					param,
					data => {
						if(data[0].length > 0){
							if(type == 'info'){
								this.params2.imageUrl = data[0]
							}else if(type == '1'){
								this.scrollimg1 = data[0]
							}else if(type == '2'){
								this.scrollimg2 = data[0]
							}else if(type == '3'){
								this.scrollimg3 = data[0]
							}
						}
					},
			        error => {
			        	
			        },config
		      	)
		  	},
		  	selectedVideo(event){
		  		var file = event.target.files[0]
		  		console.log(file)
		  	},
			addInvite(){
				var that = this
				let config = {
		  			headers: {
		  				"Content-Type": "application/json;charset=utf-8"
		  			}
		  		}
				that.params2.type = this.typelistdata.toString()
				that.params2.purpose = this.typelistdata.toString()
				var arr = []
				for(var i=0 ; i<this.PeiTaoListdata.length ; i++){
					this.PeiTaoListdata[i].isChecked = true
					arr.push(this.PeiTaoListdata[i])
				}
				if(this.YouHuiListdata.labelType){
					this.YouHuiListdata.isChecked = true
					arr.push(this.YouHuiListdata)
				}
				if(this.YaJinListdata.labelType){
					this.YaJinListdata.isChecked = true
					arr.push(this.YaJinListdata)
				}
				this.params2.scrollImageUrl = []
				console.log(this.params2)
				if(this.scrollimg1){
					this.params2.scrollImageUrl.push(this.scrollimg1)
				}
				if(this.scrollimg2){
					this.params2.scrollImageUrl.push(this.scrollimg2)
				}
				if(this.scrollimg3){
					this.params2.scrollImageUrl.push(this.scrollimg3)
				}
				that.params2.zhanShangLabels = arr
//				console.log(this.params2.scrollImageUrl)
				if(that.params2.cityCode == ""){
					Toast("请选择招商地址")
					return
				}else if(that.params2.logisticsParkCode == ""){
					Toast("请选择物流园")
					return
				}else if(that.params2.address == ""){
					Toast("请填写店铺地址")
					return
				}else if(that.params2.title == ""){
					Toast("请填写招商标题")
					return
				}else if(that.params2.contactor == ""){
					Toast("请填写招商负责人名字")
					return
				}else if(that.params2.phone == "" || that.params2.phone.length!=11){
					Toast("招商负责人电话格式错误")
					return
				}else if(that.params2.minArea == ""){
					Toast("请填写面积最小区间")
					return
				}else if(that.params2.maxArea == ""){
					Toast("请填写面积最大区间")
					return
				}else if(that.typelistdata.length == 0){
					Toast("请填选择用途类型")
					return
				}else if(that.PeiTaoListdata.length == 0){
					Toast("请填选园区配套")
					return
				}else if(that.params2.imageUrl == ''){
					Toast("请上传简介图")
					return
				}else if(that.params2.scrollImageUrl.length == 0){
					Toast("请上传轮播图")
					return
				}else if(that.params2.remark == ""){
					Toast("请描述招商概况")
					return
				}else if(that.params2.remark.length > 200){
					Toast("招商概况限制字数200个")
					return
				}else{
					this.$post(ADD_ZHAOSHANGCONF,
					this.params2,
						data => {
							if(data.confId){
								Toast('发布成功')
								that.params2 = {
				                    id: '',
				                    provCode: '',
				                    cityCode: '',
				                    adminDevisionCode: '',
				                    title: '',
				                    type: '',
				                    minArea: '',
				                    maxArea: '',
				                    purpose: '',
				                    address: '',
				                    phone: '',
				                    contactor: '',
				                    price: '',
				                    minPrice: '',
				                    maxPrice: '',
				                    summary: '',
				                    nearby: '',
				                    imageUrl: '',
				                    videoUrl: '',
				                    detailImgUrl: '',
				                    scrollImageUrl: [],
				                    remark: '',
				                    logisticsParkCode: '',
				                    trafficSituation: '',
				                    contactorAvatarUrl: '',
				                    zhanShangLabels: [],
				                    area: 'm²',
				                    place: '',
				                }
								that.PeiTaoListdata = []
								that.YouHuiListdata = {}
								that.YaJinListdata = {}
								that.typelistdata = []
								that.scrollimg1 = ""
								that.scrollimg2 = ""
								that.scrollimg3 = ""
								that.adminDevision = "区域"
								that.prov = "省份"
								that.city = "城市"
								that.parkName = ""
							}
						},
				        error => {
				        	
				        },config
			      	)
				}
			},
			closePickPark(obj){
				this.showPickPark = false
				if(obj.parkName){
					this.parkName = obj.parkName
					this.params2.logisticsParkCode = obj.parkCode
				}
			},
			emitCity(obj){
				var that = this
				this.showPickCity = false
				this.parkName = ""
				this.params2.logisticsParkCode = ""
				this.params2.provCode = obj.provinceValue
                this.params2.cityCode = obj.cityValue
                this.params2.adminDevisionCode = obj.areaValue
                this.prov = obj.provinceText
                this.city = obj.cityText
                this.adminDevision = obj.areaText
                this.$get(GET_PARKDISTRICTCODEWITHTICKET,
					{
						provCode: this.params2.provCode,
                        cityCode: this.params2.cityCode,
                        districtCode: this.params2.adminDevisionCode
					},
					data => {
						that.parkList = data
					},
			        error => {
			        	Toast(error)
			        }
		      )
			},
			addType(type){
				var that = this
				var obj = {
                    labelName: "",
                    isCustom: true,
                    labelType: type,
                    isChecked: false
               }
				MessageBox.prompt('请输入标签名').then(({ value, action }) => {
					if(!value){
						Toast("请输入新增名字")
						return
					}
					if(type == 'PeiTao'){
						obj.labelName = value
						that.PeiTaoList.push(obj)
					}else if(type == 'YouHui'){
						obj.labelName = value
						that.YouHuiList.push(obj)
					}else if(type == 'YaJin'){
						obj.labelName = value
						that.YaJinList.push(obj)
					}
				},cancel=>{
					
				});
			}
		},
		mounted(){
			
		}
	}
</script>

<style lang="sass" scoped>
	@import "./inviteBusiness";
</style>